<div class="am-flex-align gap-s ready-to-review-title" [class.am-flex-center]="sidebarMinified" (click)="togglePreferences()">
  @if ( sidebarMinified) { <span class="font-icon icon-mail-config" [class.color-blue]="userNotificationValue !== 'off'"></span> }
  @if (!sidebarMinified) { <span class="ellipsis-xs"                [class.color-blue]="userNotificationValue !== 'off'">E-Mail Benachrichtigungen</span> }
  <div class="web-tooltip border-blue medium">
    @if ( isTimeTracking) { <span class="tooltip-title">Sie erhalten eine E-Mail Benachrichtigung, wenn Sie Tätigkeitsnachweise nicht zu dem definierten Zeitpunkt freigegeben haben.</span> }
    @if (!isTimeTracking) { <span class="tooltip-title">Sie erhalten eine E-Mail Benachrichtigung, wenn neue Rechnungen vorliegen.</span> }
  </div>
  @if (!sidebarMinified) { <span class="am-flex-center mla pl-xs pt-xs pb-xs color-title-grey icon-arrow-down" [class.rotate]="collapsePreview"></span> }
</div>
<ul class="ready-to-review-options">
  @for (option of readyToReviewOptions; track option) {
    <li class="am-flex-align ml-xxs hover-active-blue"
       [class.active]="userNotificationValue === option.value"
       (click)="updatePreferences(option.value)">
      <span class="circle-10 b-secondary-grey mr-s option-circle"></span>
      <span class="ellipsis-xs">{{ option.name }}</span>
    </li>
  }
</ul>
